import { forwardRef, useImperativeHandle, useState } from "react";
import { Modal as ModalBootstrap } from "react-bootstrap";
import { ExButton } from "../ExButton";
import { Title, Icon } from "./components";

export interface ModalRef {
    openModal: () => void;
    closeModal: () => void;
    setLoading: (loading: boolean) => void;
}

export const Modal = forwardRef<ModalRef, any>((props, ref) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    function openModal() {
        setShow(true);
    }

    function closeModal() {
        setShow(false);
    }

    useImperativeHandle(ref, () => ({
        openModal,
        closeModal,
        setLoading
    }));

    return (
        <ModalBootstrap
            show={props.show || show}
            onHide={() => props.onHide ? props.onHide() : closeModal()}
            backdrop={props.backdrop || true}
            centered={props.top ? false : true}
            size={props.size ? props.size : undefined}
        >
            <ModalBootstrap.Header className="p-3">
                <Title>
                    <Icon>{props?.icon}</Icon>
                    {props.title}
                </Title>
            </ModalBootstrap.Header>
            <ModalBootstrap.Body>
                {props.children}
            </ModalBootstrap.Body>
            <fieldset disabled={loading} >
                <ModalBootstrap.Footer>
                    <ExButton secondary onClick={() => props.cancel ? props.cancel() : closeModal()}>Cancelar</ExButton>
                    {props.success && <ExButton onClick={() => props.success()}>Confirmar</ExButton>}
                </ModalBootstrap.Footer>
            </fieldset>
        </ModalBootstrap>
    );
});
